import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { CommunityNotificationSettingsDataObject } from 'models/service';

export type UpdateNotificationsSettingsRequest = {
  email_notifications_settings: {
    enable_notifications?: boolean;
    events?: boolean;
    giving?: boolean;
    newsfeed?: boolean;
    program?: boolean;
  };
  push_notifications_settings: {
    enable_notifications?: boolean;
    events?: boolean;
    giving?: boolean;
    newsfeed?: boolean;
    program?: boolean;
  };
};

export const updateNotificationsSettings = async ({
  data,
  id,
}: {
  data: UpdateNotificationsSettingsRequest;
  id: string;
}) =>
  apiClient.put<CommunityNotificationSettingsDataObject, ApiClientResponse<CommunityNotificationSettingsDataObject>>(
    routes.community.notifications.update(id),
    data,
  );
